import { AxiosResponse, isAxiosError } from 'axios';
import { createLogger, serializeError } from 'logging';

import { PromoUrl } from '@videoblocks/subscription-service-client';

import { promoApi } from './subscriptionServiceConfig';

const logger = createLogger('PromoUrlApi');

/**
 * Resolves a promotional URL slug to its associated promo code and plan.
 * The returned data is used to redirect users to checkout with a pre-applied
 * promo code, allowing unauthenticated users to proceed to the sign-up flow.
 * Returns null if the slug is not found or inactive.
 */
const getPromoUrlBySlug = async (slug: string): Promise<PromoUrl | null> => {
    try {
        const result = await promoApi.getPromoUrlBySlug({ slug });
        return result.data;
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response?.status === 404) {
                logger.info({ slug }, 'Promo URL slug not found or inactive');
                return null;
            }
            logger.warn({ error: serializeError(error), slug }, 'Error fetching promo URL by slug');
        } else {
            logger.error({ error: serializeError(error), slug }, 'Unexpected error fetching promo URL by slug');
        }
        return null;
    }
};

export const PromoUrlApi = {
    getPromoUrlBySlug,
};
